export const MY_RECEIPTS_PAGE_RECORDS = "MY_RECEIPTS_PAGE_RECORDS";
export type MY_RECEIPTS_PAGE_RECORDS = typeof MY_RECEIPTS_PAGE_RECORDS;
